// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBuE6_GI8clTPHi4jyVgdAUikiPJLQ4Jc4",
  authDomain: "prealpha-dontbefat.firebaseapp.com",
  projectId: "prealpha-dontbefat",
  storageBucket: "prealpha-dontbefat.firebasestorage.app",
  messagingSenderId: "471563228585",
  appId: "1:471563228585:web:d72cf4684c5270bd7020b8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app; // Export the initialized app